import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { RsbService } from 'src/app/service/rsb.service';
@Component({
  selector: 'app-specifications',
  templateUrl: './specifications.component.html',
  styleUrls: ['./specifications.component.css']
})
export class SpecificationsComponent implements OnInit {

  @Output() showNextPage: EventEmitter<number> = new EventEmitter();
  propertyForm: FormGroup;
 
  constructor(
    private lookupModel : RsbLookupModel,
    private fb: FormBuilder,
    private  rsbService:RsbService
  ) { }
  // masterBedroomWalls:string;
  // masterBedroomFlooring:string;
  // otherBedroomFlooring:string;
  // walls:string;
  // livingAreaFlooring:string;
  specifications:any;
  ngOnInit(): void {
    this.specifications = this.lookupModel.getVendorProperty() ? this.lookupModel.getVendorProperty().specifcations : {};
    this.propertyForm = this.fb.group({
      masterBedroomFlooring:[this.specifications && this.specifications.masterBedroomWalls ? this.specifications.masterBedroomWalls :'' ],
      masterBedroomWalls:[this.specifications && this.specifications.masterBedroomFlooring ? this.specifications.masterBedroomFlooring : ''],
      otherBedroomFlooring:[this.specifications && this.specifications.otherBedroomFlooring ? this.specifications.otherBedroomFlooring : ''],
      walls:[this.specifications && this.specifications.walls ? this.specifications.walls :''],
      livingAreaFlooring:[this.specifications && this.specifications.livingAreaFlooring ? this.specifications.livingAreaFlooring:'']
    })
  }
  back() {
    this.showNextPage.emit(7)
  }
  submit(formValue :any) : void {
   this.specifications = formValue
    let property = this.lookupModel.getVendorProperty();
    property.specifications = this.specifications;
    this.lookupModel.setVendorProperty(property);
    this.rsbService.addUpdateListings(property).subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        if (rsp.contents.listingId) {
          property.listingId = rsp.contents.listingId;
  
        }
        
        this.showNextPage.emit(9);
      }
    });
    // this.showNextPage.emit(10);
  }

  get masterBedroomFlooring() {return this.propertyForm.get('masterBedroomFlooring')}

  get masterBedroomWalls() {return this.propertyForm.get('masterBedroomWalls')}

  get otherBedroomFlooring() {return this.propertyForm.get('otherBedroomFlooring')}

  get walls() {return this.propertyForm.get('walls')}

  get livingAreaFlooring() {return this.propertyForm.get('livingAreaFlooring')}
}
